export default __webpack_public_path__ + "static/media/Arro.5782c191.png";